export const crmInfo = ({ crm }) => crm;
export default {};
